import React from 'react';

import { trpc } from '@/trpc/client';
import { LoadingIndicator, TranslatedErrorMessage } from '@/ui/controls';
import { Card } from '@/ui/layout';

import { BookingManagementCard } from './BookingManagementCard.component';

interface BookingManagementCardWithExternalIdProps {
  userId: string;
}

// @deprecated
export const UpcomingBookingList: React.FC<
  BookingManagementCardWithExternalIdProps
> = () => {
  // @deprecated
  const { isLoading, error, data } =
    trpc.bookingManagement.upcomingBookings.useQuery();

  if (isLoading) {
    return <LoadingIndicator style="dark" />;
  }

  if (error) {
    return (
      <Card rounded>
        {error.data?.domainError ? (
          <TranslatedErrorMessage
            domainError={error.data?.domainError}
            textAlign="center"
          />
        ) : (
          <TranslatedErrorMessage dictionaryKey="generic" textAlign="center" />
        )}
      </Card>
    );
  }

  return (
    <>
      {data.map(({ hotelReferenceId, id, cancellable }) => (
        <BookingManagementCard
          key={id}
          hotelSlug={hotelReferenceId}
          bookingId={id}
          cancellable={cancellable}
        />
      ))}
    </>
  );
};
